<script setup>
import {computed} from "vue";
import {usePage} from "@inertiajs/vue3";

const props = defineProps({
    name: String,
    enabled: {
        type: Boolean,
        default: true,
    },
    compute: Boolean
})

const showIcon = computed(() => {
    if (!props.enabled)
        return true;

    if (!props.name && !props.enabled)
        return true;

    if (props.enabled && !props.compute)
        return false;

    return !usePage().props.user.features?.map(el => el.feature_name).includes(props.name)
})
</script>

<template>
    <i v-if="showIcon" class="pi pi-crown text-yellow-600"></i>
</template>

<style scoped lang="scss">

</style>
